import qs from 'qs'
import _omit from 'lodash/omit'
import { useRouter } from 'next/router'
import ProviderImagesComponent from './ProviderImagesComponent'
import { keys } from './constants'
import styles from './index.module.scss'
import { pageRoutes } from 'constants/routing'
import { PAGINATION_LIMIT } from 'constants/api'
import useBreakpoint from 'hooks/useBreakPoint'
import PracticePanelSection from './PracticePanelSection'
import { CTA_CLASSES } from 'constants/common'
import _isEmpty from 'lodash/isEmpty'
import {
  extractKeywordFromQuery,
  getPartnershipCodeFromSearchQuery,
} from 'utils/b2bDetails'

type PracticeCardProps = {
  practice: Practice
  selected: boolean
  currentProviderAvailabilityFilter?: ProviderFilter[]
  otherProvidersForPractice: ProviderMetadataForPractice[]
  onSelectPractice?: (practice: Practice) => void
}

const PracticeCard: React.FC<PracticeCardProps> = ({
  practice,
  otherProvidersForPractice,
}) => {
  const { query } = useRouter()
  const {
    id: practiceId,
    latitude,
    longitude,
    state,
    city,
    stateName,
    country,
  } = practice

  const partnershipCode =
    extractKeywordFromQuery(query) || getPartnershipCodeFromSearchQuery()

  const commonAvailabilitiesForPractice = []
  otherProvidersForPractice.forEach((provider) => {
    commonAvailabilitiesForPractice.push(...provider.availabilityTypeIds)
  })

  const newQuery = qs.stringify(
    {
      ...(practiceId && { practiceId }),
      ...(latitude && { latitude }),
      ...(longitude && { longitude }),
      ...(state && { state }),
      ...((city || stateName) &&
        country && {
          location: `${city || stateName}, ${country}`,
        }),
      ...(!_isEmpty(partnershipCode) && {
        partnershipCode: partnershipCode,
      }),
      limit: PAGINATION_LIMIT.toString(),
      offset: '0',
    },
    { addQueryPrefix: true, encode: false, arrayFormat: 'brackets' }
  )
  const providersPageWithPracticeURL = `${pageRoutes.PROVIDER_SEARCH}${newQuery}`

  const navigateToProvidersPage = () => {
    keys.map((key) => {
      sessionStorage.setItem(key, practice[key])
    })
    const location = `${practice.city}, ${practice.state}, ${practice.country}`
    sessionStorage.setItem('location', location)
    sessionStorage.removeItem('sessionType')
  }

  const { isExtraLargeSize, isMobileScreen } = useBreakpoint()

  return (
    <PracticePanelSection
      logoUrl="/icons/users-round.svg"
      logoAltText="More providers from this practice"
      title="More providers from this practice"
      buttonAriaLabel="More providers practice"
      practicePanelLinkHref={providersPageWithPracticeURL}
      handleLinkClick={navigateToProvidersPage}
      containerClass={styles.practice_panel_margin}
      isInternalLink
    >
      <div
        className={`${styles.other_provider_practice_section} ${CTA_CLASSES.moreProviders}`}
      >
        <div className={styles.provider_images_section}>
          <ProviderImagesComponent
            otherProvidersForPractice={otherProvidersForPractice}
            numberOfImagesToDisplay={
              isMobileScreen ? 3 : isExtraLargeSize ? 2 : 4
            }
            imagesWithBorder={true}
          />
        </div>
        <span className="~font-gibson ~font-normal ~text-black ~text-base">
          {otherProvidersForPractice?.length || 0}
          &nbsp;providers available
        </span>
      </div>
    </PracticePanelSection>
  )
}

export default PracticeCard
